import React from 'react';

interface OverflowGridProps {
  visibleItems: number;
  modifiers?: string;
  forwardedRef?: { current: null | HTMLDivElement };

  children?: React.ReactNode[];
  onNavigate?: (index: number) => void;
}

const OverflowGrid = React.forwardRef(
  (
    { children, visibleItems, modifiers, forwardedRef, onNavigate }: OverflowGridProps,
    ref: React.ForwardedRef<HTMLDivElement | null>,
  ) => {
    const [offset, setOffset] = React.useState(0);
    const onSetOffset = (nextOffset: number): void => setOffset(nextOffset);

    if (!children || !children?.length) return null;

    const onNext = () => {
      onSetOffset(offset + 1);
      if (onNavigate) onNavigate(offset + 1);
    };

    const onPrev = () => {
      onSetOffset(offset - 1);
      if (onNavigate) onNavigate(offset - 1);
    };

    return (
      <div data-wx-overflowgrid={`desktop-${visibleItems} ${modifiers || ''}`} data-offset={offset}>
        <div className="overflow-grid-container">
          <div className="overflow-grid" ref={forwardedRef ? forwardedRef : ref}>
            {children}
          </div>
        </div>
        {offset !== 0 && (
          <div className="offset-btn offset-btn-prev">
            <button type="button" data-wx-actionbutton="" title="Föregående" onClick={onPrev}>
              <i className="icon-chevron-left no-margin" />
            </button>
          </div>
        )}
        {children.length - (visibleItems + offset) > 0 && (
          <div className="offset-btn offset-btn-next">
            <button type="button" data-wx-actionbutton="" title="Nästa" onClick={onNext}>
              <i className="icon-chevron-right no-margin" />
            </button>
          </div>
        )}
      </div>
    );
  },
);

export default OverflowGrid;
